import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import debounce from "lodash/debounce";
import PackagesService from "../../../services/PackagesService";
import AdminService from "../../../services/AdminService";
import AreasService from "../../../services/AreasService";
import SearchService from "../../../services/SearchService";
import AreasContainer from "../../partials/areas/Container";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";
import LoadingSVG from "../../helpers/LoadingSVG";

class PackageCreateForm extends Component {

    state = {
    	isLoadingAreas: false,
    	formData: { areas: [] },
    	errors: {},
    	areas: [],
    }
	
	onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }
	
	onBudgetChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: parseFloat(e.target.value) } });};
	
	onCustomerAsyncChange = (option, name, selected) => {
		if (option !== null) {
			this.setState({isLoadingAreas:true, formData: {}});
			new AreasService(this).index(0,`customer_id=${option.id}`).then((res) => {
				this.setState({
					isLoadingAreas: false,
					areas: this.loadAreas(res.data.areas),
					formData: {
						...this.state.formData,
						areas: []
					}
				});
			}).catch((err) => {
				this.setState({isLoadingAreas:false});
				HandleError(err, this);
			});
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.id || "" } });
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}

	onChangeAreaValue = (e, area) => {
		this.setState({
			formData: {
				...this.state.formData,
				areas: this.state.formData.areas.map((item) => (
					item.id !== area.id ? item
						:
						{
							id: area.id,
							name: area.name,
							value: parseFloat(e.target.value) > 0 ? parseFloat(e.target.value) : null,
						}
				))
			}
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({savePackageLoading: true, errors:{}});
		this.packageService.store(this.state.formData).then((res) => {
			this.setState({savePackageLoading: false});
			NotificationManager.success("Package created.","Success!");
			this.props.history.push("/packages");	 
		}).catch((err) => {
			this.setState({savePackageLoading: false});
			HandleError(err, this);
		});
	}

	loadAreas = (areas) => {
		if (areas && Array.isArray(areas)) {
			return areas.map((area) => ({ id: area.id, name: area.name, value: area.pivot ? area.pivot.hours : null }));
		}
		return [];
	}

	handleAsyncSearch = (input = null, attribute, extra, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
		}
		this.asyncCallback(input, attribute, extra, callback);
	}

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, {options: res.data , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);

	dropedNewArea = (newArea) => {
		this.setState((prevState)=>({
			areas: prevState.areas.filter((val, i) => (i !== newArea.index)),
			formData:{
				...this.state.formData,
				areas: [...this.state.formData.areas,newArea.area]
			}
		}));
	}

	removeNewArea = (removedArea,index)=>{
		this.setState((prevState) => ({
			areas:[...this.state.areas, removedArea],
			formData: {
				...this.state.formData,
				areas: prevState.formData.areas.filter((val, i) => (i !== index)),
			}
		}));
	}

	usersAdminService = new AdminService(this,"users");     
	packageService = new PackagesService(this);
	areasService = new AreasService(this)
	searchService = new SearchService(this);

	render() {
		const { savePackageLoading, formData, errors, selectedCustomer, isLoadingAreas, areas } = this.state;
		return (
    		<React.Fragment>
    			<Row>
					<form onSubmit={this.onSubmit}>
						<Col md={6} sm={6} xs={12}>
							<span className="column-title">Package details</span>	

							<FormGroup validationState={errors.name && "error"}>
								<ControlLabel>Name</ControlLabel>                                  
								<FormControl type="text" name="name" placeholder="Enter name" value={formData.name || ""} onChange={this.onChange}/>						
								{errors.name && <InlineError text={errors.name} />}								                                							
							</FormGroup>

							 <FormGroup validationState={errors.customer_id && "error"} >
								<ControlLabel>Customer</ControlLabel>	
								<Select.Async
									onChange={(option) => { this.onCustomerAsyncChange(option, "customer_id", "selectedCustomer"); }}
									name="customer_id"
									placeholder="Search customer"
									labelKey="full_name"
									valueKey="id"
									value={selectedCustomer}
									loadOptions={(e,c)=>this.handleAsyncSearch(e,"user","roles=3",c)}
									multi={false}
								/>
								{ errors.customer_id && <InlineError text={errors.customer_id} /> }
							</FormGroup>

							<FormGroup validationState={errors.budget && "error"}>
								<ControlLabel>Budget</ControlLabel>
								<FormControl type="number" name="budget" placeholder="Enter project budget" value={formData.budget || ""} onChange={this.onBudgetChange} />
								{errors.budget && <InlineError text={errors.budget} />}
							</FormGroup>
							
							<FormGroup validationState={errors.description && "error"}>
    							<ControlLabel>Description</ControlLabel>
    							<FormControl componentClass="textarea" name="description" placeholder="Enter project description" value={formData.description || ""} onChange={this.onChange}/>
								{errors.description && <InlineError text={errors.description} />}    						
							</FormGroup>																										
    					</Col>	

						<Col md={6} sm={6} xs={12} >
							<span className="column-title">Areas</span>
							<div className="skills-container">
								<div className="all-skills">
									{ isLoadingAreas ?
										<React.Fragment>
											<LoadingSVG />
										</React.Fragment>
										:
										<React.Fragment>
											<AreasContainer											
												allAreas={areas}
												areas={formData.areas}
												errors={errors}
												onChangeAreaValue={this.onChangeAreaValue}
												dropedNewArea={this.dropedNewArea}
												removeNewArea={this.removeNewArea}
											/> 										
										</React.Fragment>
									}
								</div>
							</div>
						</Col>

						<Col md={12} sm={12} xs={12}>
							<Button className="btn-crud" bsStyle="primary" disabled={savePackageLoading} type="submit">{savePackageLoading?"Saving...":"Save"}</Button> 
							{ savePackageLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }		
    					</Col>
					</form>						
    			</Row>
    		</React.Fragment>
    	);
	}
}
PackageCreateForm.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default PackageCreateForm;


// WEBPACK FOOTER //
// ./src/components/forms/packages/PackageCreateForm.js